// //错误报告配置
import axios from 'axios'
import qs from 'qs'
import baseFunc from "../util/base"
export default class {
Errorreport(data){
    data = baseFunc.prototype.encryption(data);
    return new Promise((resolve, reject) => {
         let url = "/commonapi/report";
        axios.post(url, qs.stringify(data), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
            }
        }).then((res) => {
            resolve(res);
        }).catch((error) => { 
        })
    })
 }
}


// WEBPACK FOOTER //
// ./src/service/common.js